// TODO remove this file after Tr2 decom
const fileInputMap = {
    evidenceOfBusinessTurnover: 'BusinessTurnover'
}

export type InputId = keyof typeof fileInputMap;

export const categoryName = (inputId: InputId) => fileInputMap[inputId];
